import React from "react";
import { Card, Col, Row } from "react-bootstrap";
// import ImageUtils from "./ImageUtils";
import { Link } from "react-router-dom";

const SmallSquareCards = (props) => {
  // const imageUtil = new ImageUtils();
  const business = props.domaindata.domainData;
  const title = props.name;

  return (
    <>
      <div className="biz-dom-wrap py-4">
        {title && (
          <div>
            <p className="do__bu__tag">
              {title} ({business.length})
            </p>
          </div>
        )}
        <Row className="gy-3">
          {business.map((d, index) => {
            const catdatas = {
              tag: props.tag,
              value: d.key,
            };
            return (
              <Col sm={6} md={4} lg={2} xl={2} xxl={2} key={index}>
                {" "}
                <Link
                  to={`/databook/${props.tag}/${d.key}`}
                  className="widg__f"
                  state={catdatas}
                >
                  <Card className="h-100 shadow-none border rounded-1">
                    <Card.Body className="bg-transparent rounded-1">
                      <div className="main__b">
                        {/* <span role="img" className="img__b">
                          <img
                            src={imageUtil.getImage(d.key)}
                            alt="business-cards"
                          />
                        </span>
                        <span className="sub__b">
                          <span className="bd__name text-wrap">{d.key}</span>
                          <h5 className="bd__val">{d.value}</h5>
                        </span> */}
                        <div>
                          <div className="card_label"><span className="bd__name text-wrap">{d.key}</span></div>
                          <div className="card_count"><h5 className="bd__val">{d.value}</h5></div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </Col>
            );
          })}
        </Row>
      </div>
    </>
  );
};

export default SmallSquareCards;
